
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.22329 7.62977C6.22329 5.00704 8.7069 2.70698 12 2.70698C13.6315 2.70698 15.0817 3.27736 16.1261 4.17896C17.1614 5.0915 17.7768 6.31001 17.7768 7.62977V12.653C17.7768 15.2274 15.3509 17.2744 12 17.2744C8.64915 17.2744 6.22329 15.2274 6.22329 12.653V7.62977ZM4.71631 12.653V7.62977C4.71631 3.98347 8.07976 1.2 12 1.2C13.9839 1.2 15.7877 1.89453 17.1142 3.04112L17.1193 3.04558L17.1193 3.04561C18.4333 4.2024 19.2837 5.8161 19.2837 7.62977V12.653V16.3702C19.2837 20.0165 15.9203 22.8 12 22.8C8.07976 22.8 4.71631 20.0165 4.71631 16.3702V12.653ZM6.22444 16.4681C6.28527 19.0499 8.74791 21.293 12 21.293C15.2521 21.293 17.7148 19.0499 17.7756 16.4681C16.4165 17.9293 14.2855 18.7814 12 18.7814C9.82736 18.7814 7.79433 18.0113 6.43129 16.68C6.36051 16.6108 6.29153 16.5402 6.22444 16.4681Z","fill":"#16171F"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.88349 3.05325C8.21106 1.8946 10.0162 1.2 12 1.2C13.9839 1.2 15.7877 1.89453 17.1142 3.04112L17.1193 3.04558C18.4334 4.20238 19.2837 5.8161 19.2837 7.62977C19.2837 8.68486 18.9932 9.66411 18.4804 10.5034C17.2405 12.5422 14.7555 13.7581 12 13.7581C9.24457 13.7581 6.75963 12.5423 5.51968 10.5035C5.00691 9.66419 4.71631 8.68491 4.71631 7.62977C4.71631 5.8167 5.56665 4.20142 6.88349 3.05325Z","fill":"#5D5CFD"}})])
          )
        }
      }
    